import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MainNavBarComponent} from './main-nav-bar.component';
import {MatMenuModule} from '@angular/material/menu';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from "@angular/material/button";



@NgModule({
  declarations: [
    MainNavBarComponent
  ],
    imports: [
        CommonModule,
        MatMenuModule,
        RouterModule,
        MatButtonModule
    ],
  exports: [
    MainNavBarComponent
  ]
})
export class MainNavBarModule { }
